import { PaletteVariantsEnum } from "../../../lss";
/**
 * Helper to apply correct color to our InlineNotification Icon
 */
export var getIconColor = function (palette) {
    var _a;
    var iconColorMap = (_a = {},
        _a[PaletteVariantsEnum.PRIMARY] = 'primary500',
        _a[PaletteVariantsEnum.SECONDARY] = 'secondary500',
        _a[PaletteVariantsEnum.SUCCESS] = 'success500',
        _a[PaletteVariantsEnum.WARNING] = 'warning600',
        _a[PaletteVariantsEnum.DANGER] = 'danger500',
        _a);
    return iconColorMap[palette];
};
//# sourceMappingURL=getIconColor.js.map